/**
 * Documentation written by: ChatGPT - Henrik
 * This file defines cache keys for the application, specifically for use with Tanstack Query.
 * Using centralized cache keys ensures consistency, avoids hardcoding strings, and makes it easier
 * to invalidate or update cached data across the application.
 *
 * - `AUTH`: Cache key for authentication-related data.
 * - `PRODUCTS`: Cache key for the list of all products.
 * - `SINGLE_PRODUCT`: Dynamic cache key for a specific product, identified by its `id`.
 * - `CREATE_PRODUCT`: Cache key for creating a new product.
 * - `UPDATE_PRODUCT`: Dynamic cache key for updating a specific product, identified by its `id`.
 * - `USERS`: Cache key for the list of all users.
 * - `SINGLE_USER`: Dynamic cache key for a specific user, identified by their `id`.
 * - `UPDATE_USER`: Dynamic cache key for updating a specific user, identified by their `id`.
 *
 * Example Usage:
 * - Use these keys to fetch, update, or invalidate specific pieces of data in the cache.
 * - Dynamic keys like `SINGLE_PRODUCT(id)` and `UPDATE_USER(id)` ensure scoped updates for specific items.
 */

const cacheKeys = {
	AUTH: ["AUTH"],
	PRODUCTS: ["PRODUCTS"],
	SINGLE_PRODUCT: (id: string) => cacheKeys.PRODUCTS.concat([id]),
	CREATE_PRODUCT: ["CREATE_PRODUCT"],
	UPDATE_PRODUCT: (id: string) => cacheKeys.PRODUCTS.concat([id]),
	MAIN_ACCOUNTS: ["MAIN_ACCOUNTS"],
	SINGLE_MAIN_ACCOUNT: (id: string) => cacheKeys.MAIN_ACCOUNTS.concat([id]),
	ACCOUNTS: ["ACCOUNTS"],
	SINGLE_ACCOUNT: (id: string) => cacheKeys.ACCOUNTS.concat([id]),
	USERS: ["USERS"],
	SINGLE_USER: (id: string) => cacheKeys.USERS.concat([id]),
	UPDATE_USER: (id: string) => cacheKeys.USERS.concat([id]),
	GVALUE: ["GVALUE"],
	CLIENT_DATA: ["CLIENT_DATA"],
	INSURANCE_PRODUCT_DEFINITIONS: ["INSURANCE_PRODUCT_DEFINITIONS"],
};

export default cacheKeys;
